import { StablesOperationPage } from "./StablesOperationPage";

export const StablesSacar = () => (
  <StablesOperationPage
    operation="withdraw"
    title="Sacar stablecoins"
    subTitle="Envie stablecoins para carteira externa ou conta bancária. Acompanhe seus saques no histórico abaixo."
    historyType="withdrawals"
    historyTitle="Histórico de saques"
  />
);
